import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

declare const ga: any;

@Injectable()
export class AnalyticsService {
  private enabled: boolean;

  constructor(private location: Location, private router: Router,
    private http: HttpClient) {
    this.enabled = true;
  }

  // trackPageViews() {
  //   if (this.enabled) {
  //     this.router.events.pipe(
  //       filter((event) => event instanceof NavigationEnd),
  //     )
  //       .subscribe(() => {
  //         //ga('send', {hitType: 'pageview', page: this.location.path()});
  //         if (this.authenticationService.currentUserValue != null) {
  //           let data = {
  //             UserId: this.authenticationService.currentUserValue.userId,
  //             DomainName: window.location.href,
  //             DateTime: new Date(),
  //             Page: this.location.path()
  //           };

  //           this.logNavigationActivity(data);
  //         }
  //       });
  //   }
  // }

  trackEvent(eventName: string) {
    if (this.enabled) {
      ga('send', 'event', eventName);
    }
  }

  // logNavigationActivity(data: any) {
    
  //   this.http.post<any>(`${environment.apiUrl}/Shared/LogActivity`, data)
  //     .subscribe(map(response => {
  //       if (response) {

  //       }
  //     }));
  // }
}
